import styled from 'styled-components';
import { rem } from 'polished';

export const Wrapper = styled.div`
  padding: ${rem(24)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;

  .alert {
    margin-bottom: ${rem(16)};
  }

  h3 {
    margin: 0 0 ${rem(8)} 0;
    font-size: ${rem(18)};
    font-weight: 600;
  }

  p {
    margin: 0 0 ${rem(16)} 0;
    font-size: ${rem(16)};
    color: ${({ theme }) => theme.colors.book.locationModal.text};
    line-height: 150%;
  }

  .loader {
    margin: 0 auto;
  }

  fieldset {
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;

    > div {
      margin-bottom: ${rem(16)};
    }

    button {
      width: 100%;
      margin-top: ${rem(8)};
    }
  }
`;
